module.exports = __webpack_public_path__ + "static/media/classCancel.7c2f080e.gif";